import { render, staticRenderFns } from "./applicantDetail.vue?vue&type=template&id=25c5d67c&scoped=true"
import script from "./applicantDetail.vue?vue&type=script&lang=js"
export * from "./applicantDetail.vue?vue&type=script&lang=js"
import style0 from "./applicantDetail.vue?vue&type=style&index=0&id=25c5d67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5d67c",
  null
  
)

export default component.exports